import { FormEvent } from "react"
import { Head, useForm } from "@inertiajs/react"
import { useIntl } from "react-intl"
import { AuthShell } from "@/components/AuthShell"
import { ExamSettingsFields } from "@/components/ExamSettingsFields"
import { Button } from "@/components/ui/button"
import type { ExamSettingsProps } from "@/types/exam"

export default function Welcome({ exam_versions, exam_version_id, target_exam_date }: ExamSettingsProps) {
  const intl = useIntl()
  const form = useForm({
    target_exam_date: target_exam_date ?? "",
    exam_version_id: exam_version_id ? String(exam_version_id) : "",
  })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.patch("/welcome")
  }

  return (
    <>
      <Head title={intl.formatMessage({ id: "welcome.title" })}>
        <meta name="description" content={intl.formatMessage({ id: "welcome.meta" })} />
        <meta property="og:title" content={intl.formatMessage({ id: "welcome.title" })} />
        <meta property="og:description" content={intl.formatMessage({ id: "welcome.meta" })} />
      </Head>
      <AuthShell>
        <div className="text-center">
          <h2 className="text-2xl">{intl.formatMessage({ id: "welcome.heading" })}</h2>
          <p className="mt-2 text-sm text-ink-muted">
            {intl.formatMessage({ id: "welcome.subtitle" })}
          </p>
        </div>

        <form onSubmit={submit} className="mt-6 space-y-6">
          <ExamSettingsFields
            versions={exam_versions}
            data={form.data}
            setData={form.setData}
            errors={form.errors}
          />
          <div className="callout callout-accent text-sm">
            {intl.formatMessage({ id: "welcome.note" })}
          </div>
          <Button type="submit" className="w-full" disabled={form.processing || !form.data.exam_version_id}>
            {intl.formatMessage({ id: "welcome.start" })}
          </Button>
        </form>
      </AuthShell>
    </>
  )
}
